import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

import type { IntentValuesType } from 'Deer/intent/types/IntentCommonTypes';

export type SelectedInitiativeType = {
  text: string;
  id: string;
  enabled: () => boolean;
};

export type InitiativeDateRange = { label?: string; startDate: Date; endDate: Date };

export type InitiativeIntentType = {
  id: string;
  label: string;
  onClick: () => void;
  visible: () => boolean;
  value: {
    myData?: IntentValuesType;
  };
  initiativeTypes: SelectedInitiativeType[];
  selectedInitiativeType: SelectedInitiativeType;
  selectedDateRange?: InitiativeDateRange;
  applicableLayoutValues?: string[];
  showLayoutDropdown?: boolean;
  category: 'Manage' | 'Analyze';
  isDefault?: boolean;
};

const initialState: {
  selectedIntent: null | InitiativeIntentType;
} = {
  selectedIntent: null,
};

export const initiativeIntentSlice = createSlice({
  name: 'initiativeIntent',
  initialState,
  reducers: {
    setSelectedInitiativeIntent: (state, action: PayloadAction<InitiativeIntentType>) => {
      const newState = { ...state };
      newState.selectedIntent = action.payload;
      return newState;
    },
    setSelectedInitiativeType: (state, action: PayloadAction<SelectedInitiativeType>) => {
      state.selectedIntent.selectedInitiativeType = action.payload;
    },
    setInitiativeDateRange: (state, action: PayloadAction<InitiativeDateRange>) => {
      state.selectedIntent.selectedDateRange = action.payload;
    },
  },
});

export const { setSelectedInitiativeIntent, setSelectedInitiativeType, setInitiativeDateRange } =
  initiativeIntentSlice.actions;

export default initiativeIntentSlice.reducer;

export const useSelectInitiativeSelectedIntent = () =>
  useSelector((state: { initiativeIntent: typeof initialState }) => state.initiativeIntent.selectedIntent);
